import type { GQL_ID } from '@@partner:types:graphql'
import type { Banner } from '@@partner:types:app'

import { gql, useQuery } from '@apollo/client'

export interface SingleBannerQuery {
  banner: Banner
}
export interface SingleBannerQueryVariables {
  id?: GQL_ID
  desktopStyle?: string
  mobileStyle?: string
}

export const GQL_QUERY_SINGLE_BANNER = gql`
  query ($id: ID!, $desktopStyle: String, $mobileStyle: String) {
    banner: singleBanner(id: $id) {
      id
      file_id
      mobile_file_id
      name
      url
      status

      optionOpenInNewWindow
      optionOpenInBrowser
      has_button
      button_text
      button_color
      
      bannerSlide(style: $desktopStyle) {
        url
      }
      bannerMobileSlide(style: $mobileStyle) {
        url
      }
      activeFrom
      activeUntil
      bannerType {
        id
        label
        code
      }
      i18n {
        language_code
        file_id
        mobile_file_id
        button_text
        bannerSlide(style: $desktopStyle) {
          url
        }
        bannerMobileSlide(style: $mobileStyle) {
          url
        }
      }
    }
  }
`

export const useFetchSingleBanner = ({
  id,
  desktopStyle = '1200xauto',
  mobileStyle = '800xauto'
}: SingleBannerQueryVariables) =>
  useQuery<SingleBannerQuery, SingleBannerQueryVariables>(
    GQL_QUERY_SINGLE_BANNER,
    {
      variables: {
        id,
        desktopStyle,
        mobileStyle
      },
      skip: !id,
      fetchPolicy: 'cache-and-network'
    }
  )
